import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, ref} from "vue";
import { store } from "@/store";
import NavigationLink from "@/ui/chrome/menu/NavigationLink.vue";
import SubMenuItemQlMedia from "@/ui/chrome/menu/SubMenuItemQlMedia.vue";
import SubMenuItemQlHeading from "@/ui/chrome/menu/SubMenuItemQlHeading.vue";
import MainNavigationService, { NavigationButtonState } from "./mainnavigation.service";
import HideB2BPricesButton from "@/ui/chrome/HideB2BPricesButton.vue";
import { useRouter } from "vue-router/composables";
import { sub } from "date-fns";


export default /*#__PURE__*/_defineComponent({
  __name: 'OffCanvasNavigation',
  setup(__props) {

const isAuthenticated = computed<boolean>(() => store.getters["app/isAuthenticated"]);
const isB2BAuthenticated = computed<boolean>(() => store.getters["app/isB2BAuthenticated"]);
const hideSiteModeProf = computed<boolean>(() => store.getters["app/hideSiteModeProf"]);
const isCheckoutView = computed<boolean>(() => store.getters["app/isCheckoutView"]);
const targetMode = computed<IMode>(() => store.getters["app/targetMode"]);
const selectedLanguage = computed<any>(() => store.getters["app/selectedLanguage"]);
const menu = computed<INavigationViewObject[]>(() => store.getters["app/menu"]);
const findRetailersUrl = computed<string>(() => store.getters["app/findRetailersUrl"]);
const findDistributorsUrl = computed<string>(() => store.getters["app/findDistributorsUrl"]);
const myAccountRoot = computed<INavigationViewObject | null>(() => store.getters["app/myAccountRoot"]);
const portalRoot = computed<INavigationViewObject | null>(() => store.getters["app/portalRoot"]);

const isPrivateMode = computed<boolean>(() => store.getters["app/isPrivateMode"]);
const isMenuOpen = computed<boolean>(() => store.getters["navigation/isMenuOpen"]);
const navLink = ref<{ linkRef: HTMLElement | null } | null>(null);
const submenuCloseButton = ref<HTMLElement | null>(null);



function toggleNavigation() : void {
    store.dispatch("navigation/toggleNavigation");
}
function closeNavigationOverlays() : void {
    store.dispatch("navigation/closeNavigationOverlays");
}
function toggleShowLanguageSelect() : void {
    store.dispatch("navigation/toggleShowLanguageSelect");
}

const isLocked = ref<boolean>(false);
const showSubNavigation = ref<boolean>(false);
const activeRoute = ref<INavigationViewObject | undefined>(null);

function hasChildren(item: any): boolean {
    return hasSubMenu(item);
}

function clearActiveRoute() {
    showSubNavigation.value = false;
    setTimeout(() => {
        if (!showSubNavigation.value) {
            activeRoute.value = undefined;
        }
    }, 800);
}

async function setActiveRoute(route: INavigationViewObject) {
    activeRoute.value = route;
    showSubNavigation.value = activeRoute.value !== undefined;
    await nextTick();
    if(submenuCloseButton.value) {
        submenuCloseButton.value.focus();
    }
    
}

function hasSubMenu(item: INavigationViewObject) {
    return item.submenu && item.submenu.length > 0;
}

const navigationButtonState = computed<NavigationButtonState>(() => {
    const loggedIn = isAuthenticated.value;
    const inCheckout = isCheckoutView.value;
    const hideSiteModeProfValue = hideSiteModeProf.value;

    return MainNavigationService.getNavigationButtonState({ loggedIn, inCheckout, hideSiteModeProf: hideSiteModeProfValue });
});

const router = useRouter();

function isCurrentPage(menuItem: INavigationViewObject): boolean {
    // this will ignore any query string parameters
    return router.currentRoute.path === menuItem.path;
}

return { __sfc: true,isAuthenticated, isB2BAuthenticated, hideSiteModeProf, isCheckoutView, targetMode, selectedLanguage, menu, findRetailersUrl, findDistributorsUrl, myAccountRoot, portalRoot, isPrivateMode, isMenuOpen, navLink, submenuCloseButton, toggleNavigation, closeNavigationOverlays, toggleShowLanguageSelect, isLocked, showSubNavigation, activeRoute, hasChildren, clearActiveRoute, setActiveRoute, hasSubMenu, navigationButtonState, router, isCurrentPage, NavigationLink, SubMenuItemQlMedia, SubMenuItemQlHeading, NavigationButtonState, HideB2BPricesButton }
}

})